"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpecialLinksOrder = exports.SpecialLinks = void 0;
let SpecialLinks = exports.SpecialLinks = /*#__PURE__*/function (SpecialLinks) {
  SpecialLinks["OutletShop"] = "OutletShop";
  SpecialLinks["JoinRewards"] = "JoinRewards";
  SpecialLinks["RewardsShop"] = "RewardsShop";
  SpecialLinks["SampleShop"] = "SampleShop";
  SpecialLinks["New"] = "New";
  SpecialLinks["Bestsellers"] = "Bestsellers";
  SpecialLinks["Icons"] = "Icons";
  SpecialLinks["BeautyRewards"] = "BeautyRewards";
  return SpecialLinks;
}({});
let SpecialLinksOrder = exports.SpecialLinksOrder = /*#__PURE__*/function (SpecialLinksOrder) {
  SpecialLinksOrder[SpecialLinksOrder["New"] = 0] = "New";
  SpecialLinksOrder[SpecialLinksOrder["Icons"] = 1] = "Icons";
  SpecialLinksOrder[SpecialLinksOrder["Bestsellers"] = 2] = "Bestsellers";
  SpecialLinksOrder[SpecialLinksOrder["SampleShop"] = 3] = "SampleShop";
  SpecialLinksOrder[SpecialLinksOrder["OutletShop"] = 4] = "OutletShop";
  SpecialLinksOrder[SpecialLinksOrder["RewardsShop"] = 5] = "RewardsShop";
  SpecialLinksOrder[SpecialLinksOrder["JoinRewards"] = 6] = "JoinRewards";
  SpecialLinksOrder[SpecialLinksOrder["BeautyRewards"] = 7] = "BeautyRewards";
  return SpecialLinksOrder;
}({});
